export enum IconLibrary {
    ACKNOWLEDGED = "ACKNOWLEDGED",
    ACKNOWLEDGEMENT_DISABLED = "ACKNOWLEDGEMENT_DISABLED",
    ACTIVITY = "ACTIVITY",
    ALERT_INFO = "ALERT_INFO",
    ALIGN_LEFT = "ALIGN_LEFT",
    ARCHIVE = "ARCHIVE",
    ARTICLE = "ARTICLE",
    ARROW_LEFT = "ARROW_LEFT",
    AUDIO = "AUDIO",
    BELL = "BELL",
    BELL_RING = "BELL_RING",
    BIN = "BIN",
    BOOKMARK = "BOOKMARK",
    BROADCAST = "BROADCAST",
    BRIEFCASE = "BRIEFCASE",
    BUOY = "BUOY",
    CALENDAR = "CALENDAR",
    CAMERA = "CAMERA",
    CAMERA_OFF = "CAMERA_OFF",
    CHECK = "CHECK",
    CHECK_DOUBLE = "CHECK_DOUBLE",
    CHEVRON_DOWN = "CHEVRON_DOWN",
    CHEVRON_UP_DOWN = "CHEVRON_UP_DOWN",
    CHEVRON_RIGHT = "CHEVRON_RIGHT",
    CIRCLE_CHECK = "CIRCLE_CHECK",
    CIRCLE_CLOSE = "CIRCLE_CLOSE",
    CIRCLE_LEFT = "CIRCLE_LEFT",
    CIRCLE_RIGHT = "CIRCLE_RIGHT",
    CLEAR_FIELD = "CLEAR_FIELD",
    CLOCK = "CLOCK",
    CLOSE = "CLOSE",
    COG = "COG",
    COMMENT = "COMMENT",
    COMMENT_ACTIVE = "COMMENT_ACTIVE",
    COMPETITION = "COMPETITION",
    CONTACT = "CONTACT",
    COPY = "COPY",
    DASH = "DASH",
    DOWNLOAD = "DOWNLOAD",
    DRAG = "DRAG",
    DROPDOWN = "DROPDOWN",
    EMPTY_SEARCH = "EMPTY_SEARCH",
    EXISTING = "EXISTING",
    EXTERNAL_LINK="EXTERNAL_LINK",
    FACE_ID = "FACE_ID",
    FILE_DOWNLOAD = "FILE_DOWNLOAD",
    FILTERS = "FILTERS",
    FILTERS_ACTIVE = "FILTERS_ACTIVE",
    FLAG = "FLAG",
    GLOBE = "GLOBE",
    HOME = "HOME",
    HEART = "HEART",
    HEART_ACTIVE = "HEART_ACTIVE",
    IMAGE = "IMAGE",
    IMAGE_UPLOAD = "IMAGE_UPLOAD",
    INFO = "INFO",
    KEY = "KEY",
    LIBRARY = "LIBRARY",
    LIKE = "LIKE",
    LIKE_ACTIVE = "LIKE_ACTIVE",
    LINK = "LINK",
    LINKED = "LINKED",
    LIST = "LIST",
    LIST_ITEM = "LIST_ITEM",
    LOCK = "LOCK",
    LOCKER = "LOCKER",
    LOGOUT = "LOGOUT",
    MAIL = "MAIL",
    MAP_PIN = "MAP_PIN",
    MAXIMISE = "MAXIMISE",
    MENTIONS = "MENTIONS",
    MENU = "MENU",
    MENU_MORE = "MENU_MORE",
    MIDDOT = "MIDDOT",
    MINIMISE = "MINIMISE",
    ORDER_BOTTOM = "ORDER_BOTTOM",
    ORDER_DOWN = "ORDER_DOWN",
    ORDER_TOP = "ORDER_TOP",
    ORDER_UP = "ORDER_UP",
    PAUSE = "PAUSE",
    PENCIL = "PENCIL",
    PERSON = "PERSON",
    PHONE = "PHONE",
    PLAY = "PLAY",
    RECOVERY = "RECOVERY",
    REPEAT = "REPEAT",
    RIBBON = "RIBBON",
    RSS = "RSS",
    SEARCH_GLASS = "SEARCH_GLASS",
    SEND="SEND",
    SETTINGS = "SETTINGS",
    SHARE = "SHARE",
    SKIP_BACK = "SKIP_BACK",
    SKIP_FORWARD = "SKIP_FORWARD",
    SKIP_TO_FIRST = "SKIP_TO_FIRST",
    SKIP_TO_LAST = "SKIP_TO_LAST",
    SKIP_TO_NEXT = "SKIP_TO_NEXT",
    SKIP_TO_PREVIOUS = "SKIP_TO_PREVIOUS",
    SMILEY_BELL = "SMILEY_BELL",
    SOCIAL_FACEBOOK = "SOCIAL_FACEBOOK",
    SOCIAL_X = "SOCIAL_X",
    SOCIAL_LINKED_IN = "SOCIAL_LINKED_IN",
    THRIVE = "THRIVE",
    TOUCH_ID = "TOUCH_ID",
    UNLOCK = "UNLOCK",
    USER_COG = "USER_COG",
    USER_NONE=" USER_NONE",
    USER_PASSKEY = "USER_PASSKEY",
    USER_PLUS = "USER_PLUS",
    USERS = "USERS",
    VIDEO = "VIDEO",
    WARNING = "WARNING",
    WARNING_BADGE = "WARNING_BADGE",
    WEBPAGE = "WEBPAGE",
  }
  